import { useOptions } from "./options";
export const useComposable = () => {
    //* 配置
    const options = useOptions();

    //* 响应式变量
    const refs = {
        loading: ref<boolean>(false), //* 加载状态
        excute: ref<{ label: String; value: string }>(options.tasks[0]), //* 执行类型
        sequence: ref<string>(""), //* 序列
        has_ambiguity_codes: ref<boolean>(false), //* 序列含简并碱基
        composing: ref<boolean>(false), //* 是否正在输入
    };

    //* 函数列表
    const methods = {
        //* 清空
        clear: () => {
            refs.sequence.value = "";
            refs.has_ambiguity_codes.value = false;
        },
        //* 切换模式
        switch: (value: { label: String; value: string }) => {
            refs.excute.value = value;
            methods.clear();
        },

        //* 序列转换校验
        format: () => {
            //* 数据初始化
            const keyword = refs.sequence.value.toLocaleUpperCase().trim(); //* 转换成大写
            const indexOf_T = keyword.indexOf("T");
            const indexOf_U = keyword.indexOf("U");
            //* T/U不能同时出现  仅允许输入A/T/C/G或A/U/C/G
            if (indexOf_T == -1 || indexOf_U == -1) {
                refs.sequence.value = keyword.replace(/[^\A\T\C\G\U]/g, "");
            } else {
                if (indexOf_T > indexOf_U) {
                    refs.sequence.value = keyword.replace(/[^\A\C\G\U]/g, "");
                } else {
                    refs.sequence.value = keyword.replace(/[^\A\T\C\G]/g, "");
                }
            }
        },
        //* 提交
        submit: () => {
            refs.loading.value = true;
            api.frontend(`/api/bio/reverse`, {
                method: "POST",
                data: {
                    seq: refs.sequence.value,
                    exec_type: refs.excute.value.value,
                },
                finally: () => (refs.loading.value = false),
                success: (response) => {
                    open(
                        routerResolve({ name: "SequenceProcessorResult", params: { id: response }, query: { mode: refs.excute.value.value } }).href,
                        "_blank"
                    );
                },
            });
        },
    };

    //* 响应事件
    const ons = {
        textarea: {
            input: () => {
                if (!refs.composing.value) nextTick(() => methods.format());
            },
            compositionstart: () => (refs.composing.value = true),
            compositionend: () => {
                refs.composing.value = false;
                nextTick(() => methods.format());
            },
        },
    };

    return { options, refs, methods, ons };
};
